import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export class CaseSlider {
  private swiper: Swiper | null = null

  constructor() {
    this.init()
  }

  private init(): void {
    const sliderElement = document.querySelector('.case-slider')
    if (!sliderElement) {
      console.log('Case slider element not found')
      return
    }

    console.log('Initializing case slider...')
    console.log('Slider element:', sliderElement)
    console.log(
      'Navigation elements:',
      document.querySelectorAll('.case-slider-prev, .case-slider-next')
    )
    console.log(
      'Pagination element:',
      document.querySelector('.case-slider-pagination')
    )

    // Swiperの初期化
    this.swiper = new Swiper('.case-slider', {
      modules: [Navigation, Pagination, Autoplay],

      // レスポンシブ設定
      slidesPerView: 1,
      spaceBetween: 20,

      // PCでは3枚ずつ表示
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },

      // ナビゲーション
      navigation: {
        nextEl: '.case-slider-next',
        prevEl: '.case-slider-prev',
      },

      // ページネーション
      pagination: {
        el: '.case-slider-pagination',
        clickable: true,
        dynamicBullets: true,
      },

      // 自動再生（オプション）
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },

      // ループ
      loop: true,

      // スライド効果
      effect: 'slide',

      // スピード
      speed: 600,

      // タッチ操作
      touchRatio: 1,
      touchAngle: 45,
      grabCursor: true,

      // キーボード操作
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },

      // マウスホイール操作
      mousewheel: false,

      // アクセシビリティ
      a11y: {
        prevSlideMessage: '前のスライド',
        nextSlideMessage: '次のスライド',
        firstSlideMessage: '最初のスライド',
        lastSlideMessage: '最後のスライド',
        paginationBulletMessage: 'スライド {{index}} に移動',
      },
    })

    // スライダーの初期化完了後の処理
    this.swiper.on('init', () => {
      console.log('Case slider initialized')
    })

    // スライド変更時の処理
    this.swiper.on('slideChange', () => {
      console.log('Slide changed to:', this.swiper?.activeIndex)
    })

    // タッチ開始時の処理
    this.swiper.on('touchStart', () => {
      console.log('Touch started')
    })

    // タッチ終了時の処理
    this.swiper.on('touchEnd', () => {
      console.log('Touch ended')
    })
  }

  // スライダーの破棄
  public destroy(): void {
    if (this.swiper) {
      this.swiper.destroy(true, true)
      this.swiper = null
    }
  }

  // 次のスライドに移動
  public next(): void {
    if (this.swiper) {
      this.swiper.slideNext()
    }
  }

  // 前のスライドに移動
  public prev(): void {
    if (this.swiper) {
      this.swiper.slidePrev()
    }
  }

  // 指定したスライドに移動
  public goTo(index: number): void {
    if (this.swiper) {
      this.swiper.slideTo(index)
    }
  }

  // 自動再生の開始
  public startAutoplay(): void {
    if (this.swiper) {
      this.swiper.autoplay.start()
    }
  }

  // 自動再生の停止
  public stopAutoplay(): void {
    if (this.swiper) {
      this.swiper.autoplay.stop()
    }
  }
}
